<p-carousel (onPage)="onPageChange($event)" [circular]="false" [page]="activeIndex" [value]="images">
  <ng-template let-image pTemplate="item">
    <div class="border-1 surface-border border-round m-2 text-center py-5 px-3">
      <img [alt]="image.alt" [src]="image.src" height="340" width="610" />
    </div>
  </ng-template>
</p-carousel>
